import { useMutation, useQueryClient } from "@tanstack/react-query"
import { apiFetch } from "../../../framework/api"
import { useAuthToken } from "../../../hooks/useAuthToken"
import type { CreatePreparedPushNotificationRequest, PreparedPushNotificationItem } from "../types"

export function useCreatePreparedPush() {
  const token = useAuthToken()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: CreatePreparedPushNotificationRequest) => {
      return await apiFetch<PreparedPushNotificationItem>("/admin/prepared-pushes", {
        token,
        method: "POST",
        body: JSON.stringify(data),
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["preparedPushes"] })
    },
  })
}

